
import { icons } from '@ds/main'

import translations from './Reassurance.translations'

export default {
  computed: {
    translations: () => translations,
    blocks() {
      return [
        {
          id: 'reassurance-best-offer',
          icon: icons.IconReassuranceSmileyFilled,
          title: this.$t(translations.reassuranceBestOfferTitle),
          description: this.$t(translations.reassuranceBestOfferDescription),
        },
        {
          id: 'reassurance-impact',
          icon: icons.IconReassuranceGlobeFilled,
          title: this.$t(translations.reassuranceImpactTitle),
          description: this.$t(translations.reassuranceImpactDescription),
        },
        {
          id: 'reassurance-quality',
          icon: icons.IconReassuranceArrowFilled,
          title: this.$t(translations.reassuranceQualityTitle),
          description: this.$t(translations.reassuranceQualityDescription),
        },
        {
          id: 'reassurance-service',
          icon: icons.IconReassuranceLockFilled,
          title: this.$t(translations.reassuranceServiceTitle),
          description: this.$t(translations.reassuranceServiceDescription),
        },
      ]
    },
  },
}
